export default __webpack_public_path__ + "img/favicon.4a041685812d64fdbf7d873a1e6bf367.svg";